import { msg } from "@lingui/macro";
import { MessageDescriptor } from "@lingui/core";

const customLineItemLabelTranslation: { [key: string]: MessageDescriptor } = {
  "service-fee": msg`summary.service_fee`,
  default: msg`summary.fee`,
};

export const getCustomLineItemLabelTranslation = (
  slug: string
): MessageDescriptor =>
  customLineItemLabelTranslation[slug] ||
  customLineItemLabelTranslation.default;

const customLineItemDescriptionTranslation: {
  [key: string]: MessageDescriptor;
} = {
  "service-fee": msg`summary.service_fee_description`,
};

export const getCustomLineItemDescriptionTranslation = (
  slug: string
): MessageDescriptor | undefined => customLineItemDescriptionTranslation[slug];

const customLineItemDataTestids: { [key: string]: string } = {
  "service-fee": "service-fee",
};

export const getCustomLineItemDataTestid = (slug: string): string | undefined =>
  customLineItemDataTestids[slug];
